import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsVoucherGroupsTagsCacheKeys: AllRouteEndpoints[] = ["/integrations/voucher_groups"];
